// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3l75a","choiceBoxes":"toolbarselects_choiceBoxes__IqNuF","simpleField":"toolbarselects_simpleField__30qQD"};